// @flow
import alt from '../alt';

import NotificationActions from '../actions/NotificationActions';

import _ from 'underscore';
import t from '../trans';
import DiagnosticsActions from "../actions/DiagnosticsActions";
import DiagnosticsSource from "../sources/DiagnosticsSource";
import rootStore from "./index";

/**
 * Diagnostikaparameetrite hoidmise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */
class DiagnosticsStore {
    constructor() {
        this.state = {
            diagnostics: [],
            state: "OK"
        };
        this.bindActions(DiagnosticsActions);
        this.exportAsync(DiagnosticsSource);
    }

    /**
     * Toote laadimise käivitamine
     */
    onFetch(info) {
        this.setState({state: "PROCESSING"});
        let p = this.getInstance().fetch();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    /**
     * Toote laadimine ebaõnnestus
     */
    onFetchFailed(error) {
        this.processError(error);
    }

    processError(error) {
        let message = t('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) {
                message = error.response.data.error.message;
            }
            else {
                switch (error.response.status) {
                    case 401:
                    case 403:
                        message = t("Invalid password");
                        break;
                    case 503:
                        message = t("Service unavailable");
                        break;
                    default:
                        message = t("Server error");
                }
            }
            switch (error.response.status) {
                case 401:
                case 403:
                    // Authentication required
                    console.log("DiagnosticStore.processError(): STATUS 401/403: invalidating session");
                    rootStore.sessionStore.invalidate();
                    this.setState({state: "FAIL"});
                    break;
                default:
                    this.setState({state: "FAIL"});
            }
        } else {
            this.setState({state: "FAIL"});
        }
        NotificationActions.error.defer(message);
    }

    onFetchDone(response) {
        try {
            if (!_.has(response.data, 'diagnosticsResult')) throw t("Server error");
            if (response.data.diagnosticsResult == null) this.setState({diagnostics: {}, state: "OK"});
            else this.setState({diagnostics: response.data.diagnosticsResult, state: "OK"});
        } catch (e) {
            if (!_.isString(e)) {
                console.log(e.toString());
                NotificationActions.error.defer(t("Server error"));
            }
            else NotificationActions.error.defer(e);
            this.setState({state: "FAIL"});
        }
    }
}

export default alt.createStore(DiagnosticsStore, 'DiagnosticsStore');
